<div class="menu grey" [ngStyle]="notFlexMenu && {'width': '20em'}" id="navbar-small">
  @for (item of items; track item; let i = $index) {
    <a class="item" [routerLink]="item.link" [class.disabled]="item.disabled" routerLinkActive="active" [class.purpleTheme]="color == 'purple'" *checkPermission="item.permission">
      <div class="item-wrapper">
        <div class="icon-wrapper">
          <div [ngClass]="item.disabled ? 'fill-light-grey' : 'fill-grey'" class="icon" aria-label="Profile" [inlineSVG]=item.svg></div>
        </div>
        <span class="pl-2">{{item.title | translate}} @if (item.count >= 0) {
          <span>({{ item.count }})</span>
        }</span>
      </div>
    </a>
  }
</div>